<div class="tw-bg-white tw-rounded-lg tw-shadow-md tw-shadow-t-md tw-shadow-b-md tw-p-5 tw-h-[{{height}}] tw-shadow-tb data-rate-widget">
  <mh-core-lib-loader-wrapper [loading]="loading" [type]="'spinner'"
    className="tw-min-h-[180px] tw-w-full tw-flex tw-items-center tw-justify-center tw-text-4xl">
    <div class="tw-flex tw-flex-col tw-h-full tw-justify-between">
      <div class="tw-flex tw-justify-between tw-items-center tw-mb-4">
        <div>
          <h2 [mhTooltip]="tooltipTitle | translate" position="above"  class="tw-text-base tw-font-medium">{{ title | translate}} <span *ngIf="grayTitle" class="tw-text-gray-500">{{ grayTitle | translate }}</span> </h2>
          <h3 class="tw-text-xs" [ngClass]="{'tw-hidden': hideQualification}">{{ 'qualifys.nps.' + qualification + (masculineText ? '_M' : '') |
            translate }}</h3>
          <h3 class="tw-text-xs" *ngIf="subTitle" [innerHTML]="subTitle | translate"></h3>
        </div>
        <button *ngIf="slugReportButton" class="tw-text-gray-400 hover:tw-text-gray-600">

          <mh-core-lib-actions-wrapper [slug]="slugReportButton">

            <mh-download-excel *ngIf="slugReportButton.includes('response_report')" [initDate]="dates.initDate"
              [endDate]="dates.endDate" [responseRate]="true" [activeEmail]="true"
              [class]="'small'" [showBorder]="false"></mh-download-excel>
          </mh-core-lib-actions-wrapper>


          <mh-download-excel *ngIf="slugReportButton.includes('email_report')" [type]="report" [initDate]="dates.initDate"
            [endDate]="dates.endDate" [class]="'small'" [showBorder]="false" (clickGetReport)="clickReport()"></mh-download-excel>
        </button>
      </div>

      <div class="tw-flex tw-items-center">
        <div *ngIf="typeRate === 'percentage'" class="tw-relative tw-h-[100px] tw-w-[100px] tw-mr-1">
          <div mhTooltip="{{ tooltipGraph | translate }}" position="above"
            class="tw-absolute tw-h-[100px] tw-w-[100px] tw-z-10 tw-grid tw-place-content-center tw-font-bold tw-text-2xl">
            <span class="tw-text-xl tw-text-center">
              <ng-container *ngIf="totalPercentage !== null && totalPercentage !== undefined; else noValue">
                <ng-container [ngSwitch]="formatType">
                  <!-- Formato de número con un decimal y punto -->
                  <ng-container *ngSwitchCase="'decimal'">
                    {{ (totalPercentage | number: '1.1-1') | replaceChar: ',': '.' }}
                  </ng-container>
                  <!-- Formato de porcentaje -->
                  <ng-container *ngSwitchCase="'percent'">
                    {{ totalPercentage | formatPercent:true:false:true }}
                  </ng-container>
                  <!-- Formato de número entero -->
                  <ng-container *ngSwitchCase="'integer'">
                    {{ totalPercentage | number: '1.0-0' }}
                  </ng-container>
                  <!-- Formato predeterminado -->
                  <ng-container *ngSwitchDefault>
                    {{ (totalPercentage | number: '1.1-1') | replaceChar: ',': '.' }}
                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-template #noValue>-</ng-template>
            </span>
            <span *ngIf="subTitlePercentage" class="tw-text-xs tw-text-gray-400 tw-text-center">{{ subTitlePercentage }}</span>
          </div>
          <div class="progress_box">
            <mat-progress-spinner class="graph graph_box {{ qualification }}" [strokeWidth]="9" [diameter]="100"
              [mode]="'determinate'" [value]="spinnerPercentage">
            </mat-progress-spinner>
            <mat-progress-spinner class="graph total_graph" [strokeWidth]="9" [diameter]="100" [mode]="'determinate'"
              [value]="100">
            </mat-progress-spinner>
          </div>
        </div>

        <div *ngIf="typeRate === 'number'">
          <span class="tw-text-5xl tw-font-bold tw-text-gray-500">{{ totalPercentage }}</span>
        </div>

        <div *ngIf="typeRate === 'empty'">
        </div>

        <div *ngIf="typeDescription === 'listOfPercentages'" class="tw-flex-1 tw-p-2">
          <div *ngFor="let item of items; let i = index" class="tw-flex tw-items-center tw-mb-3">
            <section class="tw-flex tw-items-center" [mhTooltip]="item.tooltipStatus | translate" position="above" #titleAndDot >
              <div *ngIf="showIndicators && item.showIndicator && !hideStatusIndicators"
                class="tw-w-3 tw-h-3 tw-rounded-full tw-bg-{{ item.indicatorColor }}-500 tw-mr-2"
                [mhBlurContent]="(blurPhones && i === 1) || (blurWhatsapp && i === 1)"></div>
              <span class="tw-text-xs tw-min-w-[80px]" [mhBlurContent]="(blurPhones && i === 1) || (blurWhatsapp && i === 1)">{{ item.label | translate }}</span>
            </section>

            <section class="tw-flex tw-items-center tw-w-full" [mhTooltip]="item.labelTooltip | translate" position="above" #barAndPercentage>
              <div class="tw-flex-1 tw-h-2 tw-bg-gray-200 tw-rounded-full tw-mr-2" [mhBlurContent]="(blurPhones && i === 1) || (blurWhatsapp && i === 1)">
                <div class="tw-h-full tw-bg-blue-400 tw-rounded-full" [style.width.%]="item.percentage > 100 ? 100 : item.percentage"></div>
              </div>
              <span class="tw-text-sm tw-min-w-[37px] tw-text-right" [mhBlurContent]="(blurPhones && i === 1) || (blurWhatsapp && i === 1)">
                {{ !item.percentage ? '-' : (item.percentage | formatPercent: true:false:true) }}
              </span>
            </section>
          </div>
        </div>

        <div *ngIf="typeDescription === 'text'" class="tw-flex-1 tw-px-2 {{customTextClasses}}">
          <span class="tw-text-sm" [innerHTML]="description | translate"></span>
        </div>
      </div>

      <div class="tw-flex tw-justify-between {{styleButtons}}">
        <div *ngIf="!secondButtonStart" >
          <span [mhTooltip]="leftFooterTooltip | translate" position="above" [ngClass]="{'tw-hidden': !leftFooterText}" class="tw-text-sm tw-text-gray-500 tw-italic" [innerHTML]="leftFooterText"></span>
        </div>
        <div class="tw-flex tw-gap-4 {{secondButtonClasses}}">
          <div [mhTooltip]="blockSuperAdminActions && isSuperAdmin ? ('followup.summary.data-rate.tooltip_activation' | translate) : ''" [width]="'tw-w-fit'">
            <button *ngIf="second_button_text" [mhTooltip]="blockSuperAdminActions && isSuperAdmin ? '' : (secondButtonTooltip | translate )" position="above" class="tw-text-main tw-font-['Rubik'] tw-text-sm tw-font-semibold tw-text-end" (click)="handleSecondButtonClick()">{{ second_button_text | translate | uppercase }}</button>
          </div>
          <button *ngIf="!hidePrincipalButton" class="tw-text-main tw-font-['Rubik'] tw-text-sm tw-font-semibold tw-text-end" (click)="handleViewMore()">{{ textPrincipalButton || 'commons.see_more' | translate | uppercase }}</button>
        </div>
      </div>
    </div>
  </mh-core-lib-loader-wrapper>
</div>